import { render, staticRenderFns } from "./fumetto.vue?vue&type=template&id=795e9d68"
import script from "./fumetto.vue?vue&type=script&lang=js"
export * from "./fumetto.vue?vue&type=script&lang=js"
import style0 from "./fumetto.vue?vue&type=style&index=0&id=795e9d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports